import { z } from "zod";
import {
  benefitsSection,
  companyDataSection,
  identitySection,
  locationDataSection,
  locationsSection,
  mediaSection,
  personalDataSection,
  positionsSection,
} from "./onboarding-schema";

export interface OnboardingStep {
  id: string;
  label: string;
  description: string;
  stepNumber: number | null;
}

export const ONBOARDING_STEPS: OnboardingStep[] = [
  {
    id: "willkommen",
    label: "Willkommen",
    description: "Einführung",
    stepNumber: null,
  },
  {
    id: "1",
    label: "Persönliche Daten",
    description: "Vorname & Nachname",
    stepNumber: 1,
  },
  {
    id: "2",
    label: "Unternehmensdaten",
    description: "Rechnungsadresse",
    stepNumber: 2,
  },
  {
    id: "email-verification",
    label: "Email-Bestätigung",
    description: "Bestätigungslink",
    stepNumber: null,
  },
  {
    id: "3",
    label: "Standorte",
    description: "Anzahl & Branchen",
    stepNumber: 3,
  },
  {
    id: "4",
    label: "Standortdaten",
    description: "Adresse & Ansprechpartner",
    stepNumber: 4,
  },
  {
    id: "5",
    label: "Mitarbeiterbenefits",
    description: "Vorteile für Mitarbeiter",
    stepNumber: 5,
  },
  {
    id: "6",
    label: "Stellendaten",
    description: "Positionen & Anforderungen",
    stepNumber: 6,
  },
  {
    id: "7",
    label: "Unternehmensidentität",
    description: "Arbeitgebermarke",
    stepNumber: 7,
  },
  {
    id: "8",
    label: "Medien & Branding",
    description: "Logo, Fotos, Farbe",
    stepNumber: 8,
  },
  {
    id: "9",
    label: "Zahlung",
    description: "Abo & Freischaltung",
    stepNumber: 9,
  },
];

export const DEFAULT_STEP = "willkommen";

export const STEP_VALIDATORS: Record<string, z.ZodTypeAny | null> = {
  willkommen: null,
  "email-verification": null,
  "1": personalDataSection,
  "2": companyDataSection,
  "3": locationsSection,
  "4": locationDataSection,
  "5": benefitsSection,
  "6": positionsSection,
  "7": identitySection,
  "8": mediaSection,
  "9": null,
};

export function getStepIndex(stepId: string): number {
  return ONBOARDING_STEPS.findIndex((s) => s.id === stepId);
}

export function isValidStep(stepId: string): boolean {
  return ONBOARDING_STEPS.some((s) => s.id === stepId);
}
